/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { TextField } from "@mui/material";
import { FileUpload } from "./upload-file/file-upload";
import { ConfirmDialog } from "components/page-components/dialogs/confirm-dialog";
import { EntityContext } from "../../context";
import { SVGIcons } from "../../../icons/svg-icons";
import { generateGuid } from "../../../../utils/empty-exists";
// import { UploadingFile } from "./upload-file/uploading-file";

// import { ReactComponent as XMarkIcon } from "assets/images/icons/xmark-solid-full.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/common/trash.svg";
import { ReactComponent as FileIcon } from "assets/images/icons/file-solid.svg";

const FileEntityAttributeEditor = (props) => {
    
    const reference = props.reference;
    const type = props.type;
    const name = props.name;
    const value = props.value;

    const parts = type.split(":");
    const baseType = parts[0];
    const subType = parts[1];
    const hasSubType = !!subType;
    let editorType = baseType;
    if (hasSubType) {
        editorType = subType;
    }
    
    const isList = baseType === "array";

    const [files, setFiles] = useState(value);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(false);
    // const [selectedGuid, setSelectedGuid] = useState(false);

    const entityContext = useContext(EntityContext);
    const updateAttribute = entityContext?.updateAttribute;
    
    const onUpload = (addedFiles) => {
        // let _files = structuredClone(files);
        let _files = [];
        files.map((file) => {
            const newFile = { ...file };
            const guid = file.guid ?? generateGuid();
            newFile.guid = guid;
            _files.push(newFile);
        });
        if (Array.isArray(addedFiles)) {
            _files = _files.concat(addedFiles);
        }
        setFiles(_files);
        updateAttribute(name, _files);
    };
    const onDelete = () => {
        // delete file in storage
        // delete file record
        const _files = structuredClone(files);
        _files.splice(selectedIndex, 1);
        _files.map((file) => {
            file.guid = file.guid ?? generateGuid();
        });

        setFiles(_files);
        updateAttribute(name, _files);
        setDeleteOpen(false);
    };
    const onCancel = () => {
        setDeleteOpen(false);
    };
    
    return (
        <>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">

                <div className="entity-attribute-editor-file-upload-dropzone">
                    <FileUpload 
                        reference={reference}
                        onUpload={onUpload}
                    />
                </div>

                <div className="entity-attribute-editor-file-upload-list">
                    {isList && files?.map((file,index) => {
                        const filename = file?.filename;
                        const title = file?.title;
                        const url = file?.url;
                        const guid = file?.guid;
                        // file.guid = file.guid ?? generateGuid();
                        
                        const onChangeTitle = (event) => {
                            const _title = event.target.value;
                            const _file = {
                                guid,
                                filename,
                                title: _title,
                                url
                            };
                            const _files = structuredClone(files);
                            const index = _files?.findIndex((file) => file.guid === _file.guid);
                            if (index !== -1) {
                                _files.splice(index, 1, _file);
                            }
                            setFiles(_files);
                            updateAttribute(name, _files);
                        };
                        const onClickDelete = () => {
                            setSelectedIndex(index);
                            setDeleteOpen(true);
                        };
                        
                        return (
                            <div key={`${guid}`} className="entity-attribute-editor-file-upload-list-inner">
                                {/*<UploadingFile*/}
                                {/*    key={file?.guid}*/}
                                {/*    file={file}*/}
                                {/*    onCancelFile={onClickDelete}*/}
                                {/*/>*/}
                                <div className="entity-attribute-editor-file-upload-list-row">
                                    <div className="entity-attribute-editor-file-upload-list-icon">
                                        <FileIcon />
                                    </div>
                                    <div className="entity-attribute-editor-file-upload-list-link" >
                                        <a href={url} target="_blank">{filename}</a>
                                    </div>
                                    <div className="entity-attribute-editor-file-upload-list-textfield">
                                        <TextField
                                            fullWidth={true}
                                            defaultValue={title}
                                            variant="outlined"
                                            onChange={onChangeTitle}
                                        />
                                    </div>
                                    <div className="entity-attribute-editor-file-upload-list-icon">
                                        {/*<XMarkIcon onClick={onClickDelete} />*/}
                                        <TrashIcon 
                                            onClick={onClickDelete} 
                                            className="entity-attribute-editor-icon-button"
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <ConfirmDialog
                className='common-dialog'
                open={deleteOpen}
                onCancel={onCancel}
                title={"Delete File?"}
                message={"You are about to delete this file permanently."}
                primaryAction={onDelete}
                primaryIcon={<SVGIcons.common.Delete />}
            />
        </>
    );
};

export { FileEntityAttributeEditor };
